import { render, staticRenderFns } from "./Preload.vue?vue&type=template&id=3bc5277b&scoped=true"
import script from "./Preload.vue?vue&type=script&lang=js"
export * from "./Preload.vue?vue&type=script&lang=js"
import style0 from "./Preload.vue?vue&type=style&index=0&id=3bc5277b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc5277b",
  null
  
)

export default component.exports